import React from "react";
import { CircularProgress, Box } from "@mui/material";
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import RegistrationPage from "../pages/registration/RegistrationPage";
import LoginPage from "../pages/login/LoginPage";
import MemberListPage from "../pages/members/MemberListPage";
import AddMemberPage from "../pages/members/AddMemberPage";
import SidebarLayout from "../components/layout/SidebarLayout";
import DashboardPage from "../pages/dashboard/DashboardPage";
import ApplicantListPage from "../pages/applicants/ApplicantListPage";

import UserListPage from "../pages/admin/UserListPage";
import AddUserPage from "../pages/admin/AddUserPage";
import BrevoAdminPage from "../pages/admin/BrevoAdminPage";

import ChangePasswordPage from "../pages/admin/ChangePasswordPage";

import { useAuth } from "../context/AuthContext"; // Asegurate de tener esto importado

const PrivateRoute = ({ children, allowedRoles }) => {
  const { user, rol, loading } = useAuth();

  if (loading) {
    return (
      <Box display="flex" justifyContent="center" alignItems="center" height="100vh">
        <CircularProgress />
      </Box>
    );
  }

  if (!user || !allowedRoles.includes(rol)) {
    console.warn("🚫 Acceso no autorizado, redirigiendo a /login");
    return <Navigate to="/login" />;
  }

  return children;
};

const AppRouter = () => (
  <Router>
    <Routes>
      <Route path="/login" element={<LoginPage />} />
      <Route
        path="/registration"
        element={
          <RegistrationPage />
        }
      />
      <Route
        path="/"
        element={
          <PrivateRoute allowedRoles={["admin", "gestor", "cobranzas"]}>
            <SidebarLayout>
              <DashboardPage />
            </SidebarLayout>
          </PrivateRoute>
        }
      />
      <Route
        path="/members"
        element={
          <PrivateRoute allowedRoles={["admin", "gestor", "cobranzas"]}>
            <SidebarLayout>
              <MemberListPage />
            </SidebarLayout>
          </PrivateRoute>
        }
      />
      <Route
        path="/members/add"
        element={
          <PrivateRoute allowedRoles={["admin", "gestor"]}>
            <SidebarLayout>
              <AddMemberPage />
            </SidebarLayout>
          </PrivateRoute>
        }
      />
      <Route
        path="/dashboard"
        element={
          <PrivateRoute allowedRoles={["admin", "gestor"]}>
            <SidebarLayout>
              <DashboardPage />
            </SidebarLayout>
          </PrivateRoute>
        }
      />
      <Route
        path="/applicants"
        element={
          <PrivateRoute allowedRoles={["admin", "gestor"]}>
            <SidebarLayout>
              <ApplicantListPage />
            </SidebarLayout>
          </PrivateRoute>
        }
      />
      <Route
        path="/admin/listUsers"
        element={
          <PrivateRoute allowedRoles={["admin", "gestor"]}>
            <SidebarLayout>
              <UserListPage />
            </SidebarLayout>
          </PrivateRoute>
        }
      />
      <Route
        path="/admin/addUser"
        element={
          <PrivateRoute allowedRoles={["admin", "gestor"]}>
            <SidebarLayout>
              <AddUserPage />
            </SidebarLayout>
          </PrivateRoute>
        }
      />
      <Route
        path="/admin/brevo"
        element={
          <PrivateRoute allowedRoles={["admin"]}>
            <SidebarLayout>
              <BrevoAdminPage />
            </SidebarLayout>
          </PrivateRoute>
        }
      />
      <Route
        path="/account/password"
        element={
          <PrivateRoute allowedRoles={["admin", "gestor", "cobranzas"]}>
            <SidebarLayout>
              <ChangePasswordPage />
            </SidebarLayout>
          </PrivateRoute>
        }
      />
    </Routes>
  </Router>
);

export default AppRouter;
